import React from 'react'
import './Uses.css'
import academicphoto from "../assets/academicphoto.png";
const Uses = () => {
    return (
        
            <div class="container" style={{overflow:"hidden"}}>
                <h1 id="heading-1">Journal Types and Uses</h1><br/><br/>
                
               
                <div id="section-2">
                    <div class="row">

                        <div class="col-md-4 usestyle">
                           
                            {/* <i class="fa-solid fa-book fa-4x"></i> */}
                            <img src="http://momento-static.s3.amazonaws.com/site/uses-life-journal.png" alt="" className="image"  />
                                 <h3>Personal journal</h3>
                                <p>Use Momento as a personal journey to track your daily activities and thoughts in one safe pace</p>
                            
                        </div>

                        <div class="col-md-4 usestyle">
                            <img src="http://momento-static.s3.amazonaws.com/site/uses-travel-journal.png" alt="" className="image" />
                                {/* <i class="fa-solid fa-book-atlas fa-4x"></i> */}
                                <h3>Travel Journal</h3>
                                <p>Record your travels, tracking all the places you visit, the people you meet and your daily experiences</p>
                           
                        </div>

                        <div class="col-md-4 usestyle">
                        
                          

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-work-journal.png" alt="" className="image"  />
                               
                                <h3>Work/Project journal</h3>
                                <p>Track project notes, milestones and meetings for a centralised timeline of your progress.</p>
                            
                        </div>

                        <div class="col-md-4 usestyle">
                          

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-food-journal.png" alt="" className="image"  />
                                
                                <h3>Food Journal</h3>
                                <p>Keep track of the foods you eat throughout the day. Especially useful for health and dietary reasons.</p>
                            
                        </div>

                        <div class="col-md-4 usestyle">
                            

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-health-journal.png" alt="" className="image"  />
                                <h3>Health Journal</h3>
                                <p>Track symptoms and record medication alongside your daily activity and mood.</p>
                            
                        </div>


                        <div class="col-md-4 usestyle">
                            

                                 {/* <img src="https://academicjournal.io/wp-content/uploads/2020/12/cropped-page-loading-icon.png" alt="" width="150px" height="160px"/> */}
                                 {/* <img src="https://www.colourbox.com/preview/16399149-graduation-cap-with-paper-scroll-line-icon.jpg" alt="" className="image" /> */}
                                 <img src={academicphoto} alt="academic" className="image1" />
                                <h3>Academic Journal</h3>
                                <p>Record your journey throughout your academic year.It will help you a lot.</p>
                            
                        </div>


                        <div class="col-md-4 usestyle">
                            

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-note-journal.png" alt="" className="image" />
                                <h3>Notebook</h3>
                                <p>Write notes with all the added functionality of Momento’s powerful tagging to track people and places.</p>
                           
                        </div>



                        <div class="col-md-4 usestyle">
                           

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-ideas-journal.png" alt="" className="image" />
                                <h3>Idea Log</h3>
                                <p>Keep a log of your ideas, using tags to collect your notes together and review them over time.</p>
                            
                        </div>


                        <div class="col-md-4 usestyle">
                            

                                <img src="http://momento-static.s3.amazonaws.com/site/uses-rating-journal.png" alt="" className="image" />
                                <h3>Review Log</h3>
                                <p>Keep a searchable log of films you watch, restaurants you visit, books you read and more.</p>
                           
                        </div>

                    </div>
                </div>
                {/* <div class="line"></div> */}
                <div class="section-1">
                <div style={{'width':"70vw",'margin':"50px 0px",'border-top': "1.5px solid gray"}}></div>
                    <h1 id="heading-1">Templates</h1>
                    <p class="template">With the help of some third party apps you can create templates to make capturing moments about
                     specific subjects quicker and easier.<br/> This is great for logging things like film reviews, coffee tasting notes or mood.</p>

                </div>
                <button type="submit">Find out more</button>
            </div>
       
    )
}
export default Uses